import { isNil } from "lodash-es";
import { type LookupFieldProperties } from "../fields/choices/LookupField";
import { type RadioFieldProperties } from "../fields/choices/RadioField";
import type FieldId from "../fields/FieldId";
import { type FieldType } from "../types";
import { toFieldOption } from "./selectOptionsUtil";
import type { VariableConfig, FieldConfig } from "../fields/types";
import { toVariableOption } from "../variables/variableUtil";
import type { VariableType } from "../variables/types";
import type { SelectOption, DynamicValueOption } from "../types/Menu";
import type VariableId from "../variables/VariableId.ts";

export const getPredefinedOptions = (field: FieldConfig<unknown>): SelectOption<string>[] => {
  if (field.type === "lookup") {
    const lookupField = field as FieldConfig<LookupFieldProperties>;
    if (!isNil(lookupField?.properties.options)) {
      return lookupField?.properties.options?.map((option) => ({
        variant: "text",
        label: option.name,
        value: option.id,
      }));
    }
  }
  if (field.type === "radio") {
    const radioField = field as FieldConfig<RadioFieldProperties>;
    if (!isNil(radioField?.properties.radio_options)) {
      return radioField?.properties.radio_options?.map((option) => ({
        variant: "text",
        label: option.name,
        value: option.id,
      }));
    }
  }

  return [];
};

export const getScopedFieldOptions = (
  fieldId: FieldId,
  fields: FieldConfig[],
  types: FieldType[],
): DynamicValueOption<FieldId>[] =>
  fields.filter((field) => !fieldId.equals(field.uid) && types.includes(field.type)).flatMap(toFieldOption);

export const getVariableOptions = (
  variables: VariableConfig[],
  types: VariableType[],
): DynamicValueOption<VariableId>[] =>
  variables.filter((variable) => types.includes(variable.type)).map(toVariableOption);
